import { render, staticRenderFns } from "./ReferenceNews.vue?vue&type=template&id=d4cd1436&scoped=true&"
import script from "./ReferenceNews.vue?vue&type=script&lang=js&"
export * from "./ReferenceNews.vue?vue&type=script&lang=js&"
import style0 from "./ReferenceNews.vue?vue&type=style&index=0&id=d4cd1436&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4cd1436",
  null
  
)

export default component.exports